import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  width: 216px;
  height: 100%;
  padding: 14px 12px 10px;
  display: flex;
  flex-direction: column;
  color: #a7b4c6;
  background: radial-gradient(circle at 12% 0, rgba(79, 209, 197, 0.07), transparent 22%), #111827;
  overflow: hidden;
}

.sidebar-brand {
  min-height: 42px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  gap: 11px;
  color: inherit;
  text-decoration: none;
}

.brand-mark {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 13px;
  color: #071b1d;
  background: linear-gradient(145deg, #6ee7d0, #4fd1c5);
  box-shadow: 0 9px 22px rgba(79, 209, 197, 0.18);
}

.brand-mark svg {
  width: 27px;
  height: 27px;
}

.brand-copy {
  min-width: 0;
  display: grid;
}

.brand-copy strong {
  color: #f1f5f9;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.055em;
}

.brand-copy span {
  margin-top: 3px;
  color: #607188;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.new-design {
  width: 100%;
  min-height: 38px;
  margin-top: 10px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  gap: 9px;
  border: 1px solid rgba(110, 231, 208, 0.25);
  border-radius: 11px;
  color: #e8fffa;
  background: rgba(79, 209, 197, 0.1);
  text-decoration: none;
  transition: border-color 0.18s, background 0.18s, transform 0.18s;
}

.new-design:hover {
  border-color: rgba(110, 231, 208, 0.42);
  background: rgba(79, 209, 197, 0.16);
  transform: translateY(-1px);
}

.new-design svg {
  width: 18px;
  height: 18px;
  color: #6ee7d0;
}

.new-design span {
  flex: 1;
  text-align: left;
  font-size: 12px;
  font-weight: 720;
}

.new-design em {
  color: #71849b;
  font-size: 9px;
  font-style: normal;
}

.sidebar-navigation {
  min-height: 0;
  margin: 9px -4px 0;
  padding: 0 4px 6px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar-navigation::-webkit-scrollbar {
  width: 3px;
}

.sidebar-navigation::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #2b394c;
}

.nav-section + .nav-section {
  margin-top: 7px;
}

.nav-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-label {
  padding: 0 9px;
  color: #a2afc0;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.055em;
}

.nav-label-row > small {
  padding-right: 10px;
  color: #697a90;
  font-size: 8px;
}

.nav-link {
  position: relative;
  width: 100%;
  min-height: 30px;
  margin-top: 1px;
  padding: 0 9px;
  display: flex;
  align-items: center;
  gap: 9px;
  border: 0;
  border-radius: 7px;
  color: #94a3b8;
  text-align: left;
  text-decoration: none;
  background: transparent;
  font-size: 11px;
  font-weight: 600;
  transition: color 0.16s, background 0.16s, transform 0.16s;
}

.nav-link:hover {
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.05);
  transform: translateX(1px);
}

.nav-link.active {
  color: #e9fffa;
  background: linear-gradient(90deg, rgba(79, 209, 197, 0.19), rgba(79, 209, 197, 0.08));
}

.nav-link.active::before {
  content: "";
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: 0;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: #6ee7d0;
  box-shadow: 0 0 10px rgba(110, 231, 208, 0.35);
}

.nav-link svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.nav-link.active svg {
  color: #6ee7d0;
}

.nav-link span {
  min-width: 0;
  flex: 1;
}

.nav-link > em,
.nav-link > small {
  width: 19px;
  height: 17px;
  padding: 0 4px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 5px;
  font-size: 7px;
  text-align: center;
}

.nav-link > em {
  color: #6ee7d0;
  background: rgba(110, 231, 208, 0.08);
  font-style: normal;
  font-weight: 800;
}

.nav-link > small {
  color: #8495aa;
  background: rgba(148, 163, 184, 0.07);
  font-weight: 750;
}

.recent-runs {
  padding-top: 1px;
}

.recent-runs-toggle {
  min-height: 30px;
  padding: 0 8px 0 9px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(148, 163, 184, 0.1);
  border-radius: 7px;
  color: #8291a5;
  background: rgba(255, 255, 255, 0.018);
  cursor: pointer;
  list-style: none;
  transition: color 0.16s, background 0.16s, border-color 0.16s;
}

.recent-runs-toggle::-webkit-details-marker {
  display: none;
}

.recent-runs-toggle:hover {
  color: #d2dce7;
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(148, 163, 184, 0.18);
}

.recent-runs-toggle:focus-visible {
  outline: 1px solid rgba(110, 231, 208, 0.55);
  outline-offset: 1px;
}

.recent-runs-toggle .nav-label {
  padding: 0;
  flex: 1;
}

.recent-runs-toggle:hover .nav-label {
  color: #c4cfdb;
}

.recent-runs-toggle small {
  color: #697a90;
  font-size: 8px;
  font-weight: 650;
}

.recent-runs-toggle svg {
  width: 13px;
  height: 13px;
  flex: 0 0 auto;
  transition: transform 0.18s;
}

.recent-runs[open] .recent-runs-toggle svg {
  transform: rotate(180deg);
}

.recent-runs[open] .recent-runs-toggle {
  border-radius: 7px 7px 0 0;
  background: rgba(255, 255, 255, 0.03);
}

.recent-run-list {
  margin-top: 0;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.1);
  border-top: 0;
  border-radius: 0 0 7px 7px;
}

.current-run-item {
  background: rgba(79, 209, 197, 0.045);
}

.current-run-item > em {
  color: #6ee7d0;
  font-weight: 750;
}

.recent-run {
  width: 100%;
  min-height: 30px;
  padding: 3px 9px;
  display: grid;
  grid-template-columns: 6px minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  border: 0;
  border-bottom: 1px solid rgba(148, 163, 184, 0.08);
  border-radius: 0;
  color: #8797ab;
  text-align: left;
  text-decoration: none;
  background: transparent;
  transition: background 0.16s, transform 0.16s;
}

.recent-run:hover,
.recent-run.active {
  background: rgba(255, 255, 255, 0.035);
}

.recent-run.active {
  box-shadow: inset 2px 0 #4fd1b5;
}

.recent-run > i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #607188;
}

.recent-run > div {
  min-width: 0;
  display: grid;
}

.recent-run strong,
.recent-run span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-run strong {
  color: #a8b5c5;
  font-size: 9px;
}

.recent-run span {
  margin-top: 1px;
  color: #63758b;
  font-family: "D2Coding", monospace;
  font-size: 7px;
}

.recent-run > em {
  color: #6f8095;
  font-size: 7px;
  font-style: normal;
  white-space: nowrap;
}

.recent-run > i.pass,
.recent-run > i.done {
  background: #4fd1b5;
}

.recent-run > i.review {
  background: #e7ae63;
}

.recent-run > i.running {
  background: #6699df;
}

.recent-run > i.retry {
  background: #9b7bd0;
}

.sidebar-bottom {
  margin: 0 -4px;
  padding: 7px 4px 0;
  display: grid;
  gap: 2px;
  flex: 0 0 auto;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
}

.user-card {
  width: 100%;
  border: 0;
  color: #94a3b8;
  text-align: left;
  text-decoration: none;
  background: transparent;
}

.sidebar-bottom > .nav-label {
  margin-bottom: 2px;
}

.sidebar-bottom .system-link {
  min-height: 30px;
  margin-top: 1px;
}

.user-card:hover,
.user-card.active {
  color: #dbe6f2;
  background: rgba(255, 255, 255, 0.045);
}

.logout-link:hover {
  color: #fda4af;
}

.system-link em {
  width: 17px;
  height: 17px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(110, 231, 208, 0.18);
  border-radius: 50%;
  color: #6ee7d0;
  background: rgba(110, 231, 208, 0.07);
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
}

.user-card {
  min-height: 40px;
  padding: 5px 8px;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  border-radius: 10px;
}

.user-avatar {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #e8fffa;
  background: linear-gradient(135deg, #2b6b73, #325a8b);
  font-size: 11px;
  font-weight: 800;
}

.user-card > div:nth-child(2) {
  min-width: 0;
  display: grid;
}

.user-card strong,
.user-card span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-card strong {
  color: #b9c5d3;
  font-size: 9px;
}

.user-card span {
  margin-top: 2px;
  color: #65778c;
  font-size: 7px;
}

.user-card em {
  color: #66778b;
  font-size: 13px;
  font-style: normal;
}

/* Light dashboard navigation from the supplied landing-page reference. */
:host-context(.dashboard-shell) {
  width: 100%;
  padding: 20px 16px 12px;
  color: #596476;
  background: #fff;
}

:host-context(.dashboard-shell) .sidebar-brand {
  min-height: 48px;
  padding: 0 5px;
  gap: 10px;
}

:host-context(.dashboard-shell) .brand-mark {
  width: 37px;
  height: 37px;
  border-radius: 10px;
  color: #0b2434;
  background: linear-gradient(145deg, #71e1cf, #50c9bc);
  box-shadow: 0 7px 18px rgba(37, 158, 139, 0.16);
}

:host-context(.dashboard-shell) .brand-mark svg {
  width: 24px;
  height: 24px;
}

:host-context(.dashboard-shell) .brand-copy strong {
  color: #182137;
  font-size: 13px;
  letter-spacing: 0.035em;
}

:host-context(.dashboard-shell) .brand-copy span {
  color: #8993a2;
  font-size: 7.5px;
  letter-spacing: 0.065em;
}

:host-context(.dashboard-shell) .new-design {
  min-height: 48px;
  margin-top: 16px;
  padding: 0 14px;
  border: 0;
  border-radius: 10px;
  color: #fff;
  background: linear-gradient(135deg, #171933, #11152d);
  box-shadow: 0 10px 22px rgba(17, 21, 45, 0.14);
}

:host-context(.dashboard-shell) .new-design:hover {
  border-color: transparent;
  background: linear-gradient(135deg, #222642, #12162f);
}

:host-context(.dashboard-shell) .new-design svg {
  color: #fff;
}

:host-context(.dashboard-shell) .new-design span {
  font-size: 12px;
}

:host-context(.dashboard-shell) .new-design em {
  display: none;
}

:host-context(.dashboard-shell) .sidebar-navigation {
  margin-top: 15px;
  padding-bottom: 8px;
}

:host-context(.dashboard-shell) .sidebar-navigation > .nav-section:first-child > .nav-label {
  display: none;
}

:host-context(.dashboard-shell) .nav-section + .nav-section {
  margin-top: 12px;
}

:host-context(.dashboard-shell) .nav-label {
  color: #929ba8;
  font-size: 8px;
  letter-spacing: 0.04em;
}

:host-context(.dashboard-shell) .nav-link {
  min-height: 35px;
  margin-top: 2px;
  padding: 0 10px;
  border-radius: 8px;
  color: #536073;
  font-size: 10.5px;
  font-weight: 680;
}

:host-context(.dashboard-shell) .nav-link:hover {
  color: #116f61;
  background: #f0f8f6;
}

:host-context(.dashboard-shell) .nav-link.active {
  color: #087563;
  background: linear-gradient(90deg, #e5f5f1, #edf8f6);
}

:host-context(.dashboard-shell) .nav-link.active::before {
  top: 8px;
  bottom: 8px;
  left: 1px;
  width: 2px;
  background: #1aaa91;
  box-shadow: none;
}

:host-context(.dashboard-shell) .nav-link.active svg {
  color: #118471;
}

:host-context(.dashboard-shell) .nav-link > em {
  color: #4f5969;
  background: #f0f2f4;
}

:host-context(.dashboard-shell) .nav-link > small {
  color: #7c8796;
  background: #f1f3f5;
}

:host-context(.dashboard-shell) .recent-runs {
  margin-top: 12px;
  padding: 12px 2px 0;
  border-top: 1px solid #e7ebee;
}

:host-context(.dashboard-shell) .recent-runs-toggle {
  min-height: 25px;
  padding: 0 7px;
  border: 0;
  color: #768191;
  background: transparent;
}

:host-context(.dashboard-shell) .recent-runs-toggle:hover,
:host-context(.dashboard-shell) .recent-runs[open] .recent-runs-toggle {
  color: #4f5b6b;
  background: transparent;
}

:host-context(.dashboard-shell) .recent-runs-toggle .nav-label {
  color: #7d8795;
}

:host-context(.dashboard-shell) .recent-runs-toggle small {
  color: #98a1ad;
}

:host-context(.dashboard-shell) .recent-run-list {
  margin-top: 5px;
  border: 0;
  border-radius: 0;
}

:host-context(.dashboard-shell) .recent-run {
  min-height: 30px;
  padding: 3px 8px;
  border-bottom: 0;
  border-radius: 7px;
  color: #687486;
}

:host-context(.dashboard-shell) .recent-run:hover,
:host-context(.dashboard-shell) .recent-run.active {
  background: #f5f8f8;
}

:host-context(.dashboard-shell) .current-run-item {
  min-height: 52px;
  margin-bottom: 3px;
  padding: 6px 8px;
  border: 1px solid #e2e8eb;
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 6px 15px rgba(36, 59, 70, 0.055);
}

:host-context(.dashboard-shell) .recent-run.active {
  box-shadow: inset 2px 0 #30b59f;
}

:host-context(.dashboard-shell) .current-run-item.active {
  box-shadow: inset 2px 0 #30b59f, 0 6px 15px rgba(36, 59, 70, 0.055);
}

:host-context(.dashboard-shell) .recent-run strong {
  color: #344154;
  font-size: 8.5px;
}

:host-context(.dashboard-shell) .current-run-item strong {
  color: #1f2c3f;
  font-size: 9.5px;
}

:host-context(.dashboard-shell) .recent-run span {
  color: #8a95a3;
  font-size: 6.5px;
}

:host-context(.dashboard-shell) .recent-run > em {
  color: #7f8997;
  font-size: 6.5px;
}

:host-context(.dashboard-shell) .current-run-item > em {
  color: #13806d;
}

:host-context(.dashboard-shell) .knowledge-nav {
  padding-top: 10px;
  border-top: 1px solid #e7ebee;
}

:host-context(.dashboard-shell) .sidebar-bottom {
  border-top-color: #e7ebee;
}

:host-context(.dashboard-shell) .sidebar-bottom > .nav-label {
  display: none;
}

:host-context(.dashboard-shell) .sidebar-bottom .system-link {
  min-height: 32px;
}

:host-context(.dashboard-shell) .system-link em {
  border-color: #d8e8e4;
  color: #16816e;
  background: #eff8f6;
}

:host-context(.dashboard-shell) .logout-link {
  display: none;
}

:host-context(.dashboard-shell) .user-card {
  min-height: 48px;
  margin-top: 4px;
  color: #596476;
  background: #f8fafb;
}

:host-context(.dashboard-shell) .user-card:hover,
:host-context(.dashboard-shell) .user-card.active {
  color: #263346;
  background: #f1f7f6;
}

:host-context(.dashboard-shell) .user-avatar {
  color: #fff;
  background: linear-gradient(135deg, #087b68, #075b50);
}

:host-context(.dashboard-shell) .user-card strong {
  color: #394557;
}

:host-context(.dashboard-shell) .user-card span,
:host-context(.dashboard-shell) .user-card em {
  color: #8792a0;
}`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public readonly runStorageKey: string = "mobility-ai-demo-run";
    public readonly activeRunStorageKey: string = "mobility-ai-active-run";
    public readonly runItems: any[] = [
        { id: "NX4-PTG-2404", projectId: "NX4", code: "NX", project: "NX4 Tailgate Actuator", status: "완료", statusClass: "done", journeyStep: 7, approved: true },
        { id: "EV9-FRK-1182", projectId: "EV9", code: "EV", project: "EV9 Frunk Actuator", status: "확인 대기", statusClass: "review", journeyStep: 2, approved: false },
        { id: "SD-DRV-0831", projectId: "SD", code: "SD", project: "Sliding Door Drive", status: "실행 중", statusClass: "running", journeyStep: 5, approved: false },
        { id: "GV7-SPL-0719", projectId: "GV7", code: "GV", project: "GV70 Spoiler Lift", status: "재실행 필요", statusClass: "retry", journeyStep: 4, approved: false }
    ];

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public isRunActive(id: string) {
        return location.pathname.indexOf(`/platform/runs/${id}`) === 0;
    }

    public get activeRunId() {
        let segments = location.pathname.split("/").filter(Boolean);
        if (segments[0] === "platform" && segments[2]) {
            return decodeURIComponent(segments[2]);
        }
        let storedActiveRun = "";
        try {
            storedActiveRun = localStorage.getItem(this.activeRunStorageKey) || "";
        } catch (error) {
            storedActiveRun = "";
        }
        return storedActiveRun || this.readStoredRun().runId || "NX4-PTG-2404";
    }

    public get currentRun() {
        let base = this.runItems.find(item => item.id === this.activeRunId) || this.runItems[0];
        let stored = this.readStoredRun();
        if (stored.runId !== base.id) return base;
        let journeyStep = Number(stored.journeyStep || base.journeyStep);
        let approved = Boolean(stored.approved);
        return {
            ...base,
            project: stored.project || base.project,
            status: approved ? "완료" : stored.status || base.status,
            statusClass: approved ? "pass" : journeyStep === 2 || journeyStep >= 6 ? "review" : journeyStep > 1 ? "running" : "pending",
            journeyStep,
            approved
        };
    }

    public get activeProjectId() {
        return this.currentRun.projectId || "—";
    }

    public get previousRuns() {
        return this.runItems.filter(item => item.id !== this.activeRunId).slice(0, 3);
    }

    public get currentStage() {
        const stages = [
            "자연어 입력",
            "요구사항 분석",
            "설계 대안 생성",
            "Agent 협업",
            "시뮬레이션",
            "설계안 비교",
            "최종 확정"
        ];
        let step = Math.min(Math.max(Number(this.currentRun.journeyStep || 1), 1), stages.length);
        return { step, label: stages[step - 1] };
    }

    public readStoredRun() {
        if (typeof localStorage === "undefined") return {};
        try {
            return JSON.parse(localStorage.getItem(this.runStorageKey) || "{}");
        } catch (error) {
            return {};
        }
    }

    public runLink(section: string) {
        return `/platform/${section}/${this.activeRunId}`;
    }

    public goMain(event: any = null) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        this.service.status.toggle('navbar', true);
        if (typeof location === "undefined") return;
        location.href = "/dashboard";
    }

}

export default ComponentNavSidebarComponent;